export const AUTH_ONLY = 'AUTH_ONLY';